import type { ReactNode } from 'react'

/** Etykietowane pole formularza - label nad kontrolką. */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="grid gap-1">
      <span className="text-xs uppercase text-slate-500">{label}</span>
      {children}
    </label>
  )
}
